var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUploadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 26.6667L19.9997 20L13.333 26.6667",
    stroke: "#FF0990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V35",
    stroke: "#FF0990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9828 30.6498C35.6083 29.7636 36.8925 28.3613 37.6326 26.6642C38.3726 24.9671 38.5265 23.0719 38.0698 21.2776C37.6131 19.4834 36.5719 17.8923 35.1106 16.7556C33.6492 15.6188 31.8509 15.001 29.9994 14.9998H27.8994C27.395 13.0485 26.4547 11.237 25.1494 9.70147C23.844 8.1659 22.2075 6.94623 20.3629 6.13416C18.5184 5.32208 16.5137 4.93874 14.4996 5.01295C12.4856 5.08715 10.5146 5.61698 8.73474 6.56259C6.95492 7.5082 5.41263 8.84498 4.22382 10.4724C3.035 12.0999 2.2306 13.9757 1.87108 15.9588C1.51156 17.9419 1.60629 19.9807 2.14813 21.9219C2.68998 23.8631 3.66485 25.6563 4.99945 27.1665",
    stroke: "#FF0990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 26.6667L19.9997 20L13.333 26.6667",
    stroke: "#FF0990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadIcon);
export default __webpack_public_path__ + "static/media/cloud-upload-icon.69bdab0df1c2cf108b85ed3e68de650a.svg";
export { ForwardRef as ReactComponent };